<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all batchDeliveryGroup">
        <div class="flex align-center justify-start">
            <div class="productCompleteTitle">请选择快递公司：</div>
            <el-select v-model="expressCode" filterable class="m-2" placeholder="请选择" style="width: 20%;margin-right: 20px">
                <el-option v-for="item in expressOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>

        </div>
        <div class=" flex align-center justify-start sendFileDiv">
            <div class="productCompleteTitle">请选择发货订单excel文件：</div>
            <div class="filename" v-show="filename">{{filename}}</div>
            <el-button  plain type="primary" class="tableOptionBtn" @click="sendFile">选择文件</el-button>

            <div class="downloadFile" @click="downloadFile">下载文件模板</div>
        </div>
        <div class="tableOptionBtnDiv">
            <el-button  plain type="primary" class="tableOptionBtn" @click="batchDelivery">批量发货</el-button>
        </div>
    </div>

</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import WangEditor from '@/components/wangEditor'
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";
import axios from 'axios'

export default {
    inject: ['$http', '$api', '$utils','$userUtils', '$uploadFileUtils'],
    name: "orderList",
    components: {
        baseSearch,
        basetable,
        basedialog,
        tableDataSelect,
        WangEditor
    },
    data() {
        return{
            expressCode:'',
            expressOptions: [],
            filename:'',
            deliveryFile: '',

        }
    },
    mounted() {
        //公共字典
        this.getCommonDicts();
    },

    methods:{
        /**
         * 获取用户信息
         */
        getCommonDicts() {
            let that = this;

            that.$http.post(that.$api.getCommonDictsApi,{
                "type": "快递公司编码",
            }).then(res => {
                if(res.code == 200) {
                    that.expressOptions = [];
                    res.data.forEach((item)=>{
                        that.expressOptions.push({'label':item.name,'value':item.code})
                    })
                }
            })

        },
        sendFile(){
            const input = document.createElement('input');
            input.type = 'file';
            input.style.display = 'none';
            input.addEventListener('change', this.changeHandler);

            // 挂载到DOM并触发点击
            document.body.appendChild(input);
            input.click();
        },
        /**
         * 下载模板
         */
        downloadFile(){
            let that = this;
            that.$http.post(that.$api.queryPlatformSysConfigByNameApi, {
                name: 'factoryGroupOrderSendFileTemplate'
            }).then(res => {
                if(res.code == 200) {
                    window.open(res.data.value, '_blank');
                }
            })
        },
        /**
         * 文件选择处理
         */
        changeHandler(e) {
            let that = this;
            const file = e.target.files[0];
            console.log(e.target.files[0])

            if(file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" && file.type != "application/vnd.ms-excel") {

                that.$message.warning("请上传xls、xlsx格式文件");
                return
            }else{
                this.deliveryFile = null;
                this.deliveryFile = new FormData();
                this.deliveryFile.append('file', file);
                this.filename = e.target.files[0].name;

            }

        },
        batchDelivery(){
            let that = this;

            if(this.deliveryFile.has('expressCode')){
                this.deliveryFile.delete('expressCode'); // 先删除原键
                this.deliveryFile.append('expressCode', this.expressCode);

            }else{
                this.deliveryFile.append('expressCode', this.expressCode);
            }

            axios.post(that.$api.byDeliveryFileBatchSendGroupOrdersApi, this.deliveryFile, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                console.log('上传成功',response);
                if(response.data.code == 200){
                    that.$message.success("操作成功");
                }

                // location.reload();
            }).catch(error => {
                console.error('上传失败', error);
            });

        }
    },
}
</script>

<style>
	.batchDeliveryGroup .el-input__wrapper{
		box-shadow: 0 0 0 1px #dcdfe6 inset !important;
	}
</style>
<style scoped>
.mainCont .container{
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;
}
.productCompleteTitle{
    color: #4f4f4f;
    margin-bottom: 4px;
    font-weight: 600;
    font-size: 14px;
}
.sendFileDiv{
    margin-top: 20px;
}
.downloadFile{
    margin-left: 20px;
    font-size: 14px;
    color: #4A7FF8;
    cursor: pointer;
    text-decoration: underline; /* 核心属性：显示下划线 */
    text-decoration-color: #4A7FF8; /* 下划线颜色（默认继承文本颜色） */
    text-decoration-thickness: 1px; /* 下划线粗细（支持 px、em、%） */
    text-decoration-style: solid; /* 线型：solid（实线，默认）/ dotted（点线）/ dashed（虚线）/ wavy（波浪线） */
    text-decoration-offset: 2px;
}
.tableOptionBtnDiv{
    width: 100%;
    text-align: center;
    margin-top: 40px;
}
.filename{
    color: #4f4f4f;
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 14px;
    margin-right: 6px;
}

</style>
<style>

</style>